import {ChangeDetectionStrategy, Component, effect, inject, OnInit, signal} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {PageNavInterface} from '../../core/types/page-nav/nav.interface';
import {NavBarRoutesComponent} from '../../shared/components/nav-bar-routes/nav-bar-routes.component';
import {AuthService} from '../../core/services/auth.service';
import {NavBarService} from '../../core/services/nav-bar.service';
import {EventService} from '../../core/services/event.service';

export const pageNav: PageNavInterface = {
  title: 'Profile & Settings',
  isStaticNav: true,
  items: [
    {
      id: 0,
      title: 'Events',
      path: '/',
      order: 1,
    },
    {
      id: 1,
      title: 'Edit profile',
      path: '/profile-edit',
      order: 2,
    },
    {
      id: 2,
      name: "logout",
      title: 'Logout',
      order: 3,
    }
  ]
}
export const pageNavAdmin: PageNavInterface = {
  title: 'Profile & Settings',
  isStaticNav: true,
  items: [
    {
      id: 0,
      title: 'Events',
      path: '/admin',
      order: 1,
    },
    {
      id: 1,
      title: 'Edit profile',
      path: '/profile-edit',
      order: 2,
    },
    {
      id: 2,
      name: "logout",
      title: 'Logout',
      order: 3,
    }
  ]
}

@Component({
  selector: 'app-profile',
  imports: [
    RouterOutlet,
    NavBarRoutesComponent
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileComponent implements OnInit {

  navStructure = signal<PageNavInterface>(pageNav);
  showPdfGenerateLoader = signal<boolean>(false)
  private navBarService = inject(NavBarService);
  private authService = inject(AuthService);
  private router = inject(Router);
  protected eventService = inject(EventService);
  constructor() {
    effect(() => {
      const status = this.eventService.isPdfGenerates;
      this.showPdfGenerateLoader.set(this.eventService.isPdfGenerates());
    });
  }


  ngOnInit() {
    this.navBarService.closeNavBar();
    if (this.authService.isAdmin()) {
      console.log('User logged out', pageNavAdmin);
      this.navStructure.set(pageNavAdmin);
    }
  }

  navigationEvent(_event: any) {
    this.authService.logout();
    this.router.navigate(['sign-in']).then();
  }
}
